import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useLoginLogout_FR } from './LoginFRHooks'
import { getLocationParamer } from '@/utils/common'
import Cookies from "js-cookie";
import { useTranslation } from 'react-i18next';
import { TrackPageView } from "../utils/adobeLaunch";
export const useLoginForm = ({
    loginSuccessCallback, checked, rememberConfig, verifyErrorChange, setLoading
}) => {
    const { FR_loginWithUsernamePwd, loginIncorrectMsg, setCIAMLoginIncorrectMsg, FR_loginWCIP } = useLoginLogout_FR()
    const [formData, setFormData] = useState({
        username: {
            value: "",
            isValid: true,
        },
        pwd: {
            value: "",
            isValid: true,
        },
    });
    useEffect(() => {
        if (loginIncorrectMsg) {
            if (verifyErrorChange?.includes('clearPassword')) {
                const currentFormData = {
                    username: {
                        ...formData.username,

                    },
                    pwd: {
                        ...formData.pwd,
                        value: ''
                    },
                }
                setFormData(currentFormData);
            }
            if (verifyErrorChange?.includes('clearUsename')) {
                const currentFormData = {
                    username: {
                        ...formData.username,
                        value: '',
                    },
                    pwd: {
                        ...formData.pwd,
                    },
                }
                setFormData(currentFormData);
            }

        }
    }, [loginIncorrectMsg])

    useEffect(() => {
        if (Cookies.get('accountNo') && !!rememberConfig.text) {
            setFormData(
                {
                    username: {
                        value: Cookies.get('accountNo'),
                        isValid: true,
                    },
                    pwd: {
                        value: "",
                        isValid: true,
                    },
                }
            )
        }
    }, [])
    const handleLoginClick = async () => {
        if (!handleVerify(['username', 'pwd'])) {
            return;
        }
        setLoading?.(true)
        const result = await FR_loginWithUsernamePwd(formData.username.value, formData.pwd.value)
         // login success
        if (result?.message === 'LoginSuccess') {
            sessionStorage.setItem('isBet', !!result.betAcct && result.betAcct !== 'undefined' ? '1' : '0')
            checked ? Cookies.set("accountNo", result.accountNo, { expires: 7, domain: window.globalConfig.VITE_COOKIE_DOMAIN }) : Cookies.remove("accountNo", { domain: window.globalConfig.VITE_COOKIE_DOMAIN })
            // if success get parameter goto 
            // await FR_loginWCIP(formData.username.value, formData.pwd.value);
            if (getLocationParamer('goto')) {
                window.location.href = getLocationParamer('goto')
            } else {
                loginSuccessCallback?.()
            }
        } else {
            setLoading?.(false)
        }
        // todo call login api
        // set loginFailed when login catch
    };

    const handleDataChange = (dataKey, value, isClearInvalid = false) => {
        setCIAMLoginIncorrectMsg('')
        setFormData({
            ...formData,
            [dataKey]: {
                ...formData[dataKey],
                value,
                isValid: (isClearInvalid) ? true : formData[dataKey].isValid
            },
        });
    };

    const handleVerify = (array) => {
        const currentFormData = {
            username: {
                ...formData.username,
                isValid: array.includes('username') ? !!formData.username.value.trim() : formData.username.isValid,
            },
            pwd: {
                ...formData.pwd,
                isValid: array.includes('pwd') ? !!formData.pwd.value.trim() : formData.pwd.isValid,
            },
        }
        setFormData(currentFormData);
        return currentFormData.pwd.isValid && currentFormData.username.isValid
    };

    const handleFoucs = (array) => {
        const currentFormData = {
            username: {
                ...formData.username,
                isValid: array.includes('username') ? true : formData.username.isValid,
            },
            pwd: {
                ...formData.pwd,
                isValid: array.includes('pwd') ? true : formData.pwd.isValid,
            },
        }
        setFormData(currentFormData);
    };

    return {
        formData,
        onLoginClick: handleLoginClick,
        onFormDataChange: handleDataChange,
        onVerify: handleVerify,
        handleFoucs: handleFoucs,
        loginIncorrectMsg,
    };
};

export const useChangeLanguage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const { lang: currentLang } = useParams();
    const handleChangeLanguage = () => {
        const isEn = i18n.language === 'en-us'
        const newLang = isEn ? 'zh-hk' : 'en-us'
        // // 假设语言代码是路径的第一部分
        // const searchParams = new URLSearchParams(location.search);
        // // 更新语言参数
        // searchParams.set('UIC', newLang);


        const newPathname = location.pathname.replace(
            `/${currentLang}`,
            `/${newLang}`
        );

        navigate({
            pathname: newPathname,
            search: location.search
        }, { replace: true });
        i18n.changeLanguage(isEn ? 'zh-hk' : 'en-us');
        document.documentElement.lang = isEn ? 'zh-hk' : 'en-us'
    }
    return { handleChangeLanguage }
};

export const useWcipNavigate = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    const withLangNavigate = (path, search = '', isReplace = false) => {
        const ep = getLocationParamer("EP");
        let newSearch = search
        if (ep) {
            newSearch = search ? `${search}&EP=${ep}` : `?EP=${ep}`
        }
        navigate(
            {
                pathname: `/${i18n.language}${path}`,
                search: newSearch,
            },
            { replace: isReplace }
        );
    }
    // try {
    //     TrackPageView();   
    // } catch (error) {
    //     console.error('Error in TrackPageView:', error);
    // }
    return { withLangNavigate }
}

export const useHandleUpdateSearch = () => {
    const navigate = useNavigate();
    // 1. 创建 URLSearchParams 实例，基于当前 location.search 或自行构造
    const updateRouteSearch = (key, value, replace = true) => {
        const searchParams = new URLSearchParams(location.search); // 假设 location 可通过 useLocation 获取

        // 2. 更新需要的参数，例如设置 `page` 为 2
        searchParams.set(key, value);

        // 3. 生成新的 search string
        const newSearch = searchParams.toString();

        // 4. 使用 navigate 替换当前路由
        navigate(`${location.pathname}?${newSearch}`, { replace });
    }
    return { updateRouteSearch }
};

export const useDynamicHead = (title, faviconPath) => {
    useEffect(() => {
        // 更改标题
        document.title = title;
        // 查找现有的favicon链接，如果没有则创建
        let favicon = document.querySelector('link[rel="icon"]');
        if (!favicon) {
            favicon = document.createElement('link');
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
        }
        favicon.href = faviconPath;
    }, [title, faviconPath]);
}


export function isMobileSize(size = 512) {
    return (window.matchMedia(`(max-width: ${size}px)`).matches) && sessionStorage.getItem('isDeskTopVersion') !== '1'
}

export function getScreenInfo(size) {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
        isMobileSize: isMobileSize(size)
    };
}


export const useWindowSize = (size) => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
        isMobileSize: isMobileSize(size)
    });
    const timer = useRef(null);
    useEffect(() => {
        function handleResize() {
            timer.current !== null && clearTimeout(timer.current);
            timer.current = setTimeout(() => {
                setWindowSize({ ...getScreenInfo(size) });
            }, 250);
        }
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        setWindowSize({ ...getScreenInfo(size) });
        // Remove event listener on cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
            timer.current !== null && clearTimeout(timer.current);
        }
    }, []);

    return windowSize;
};


export const useInputData = (initData) => {
    const [dataForm, setDataForm] = useState(initData)

    const onFormValueChange = (dataKey, value) => {
        console.log(value)
        const func = setDataForm
        const cloneFornParams = JSON.parse(JSON.stringify(dataForm))
        try {
            func?.((prev) => {
                return (
                    {
                        ...prev,
                        [dataKey]: {
                            ...cloneFornParams[dataKey],
                            ...value,
                        },
                    }
                )
            });
        } catch (error) {
            console.log(error);
        }
    }


    const handleVerfiy = (array) => {
        const cloneFornParams = JSON.parse(JSON.stringify(dataForm))
        const data = initData
        Object.keys(data).forEach((d) => {
            console.log(array)
            if (array.includes(d)) {
                console.log(d)
                cloneFornParams[d] = { ...cloneFornParams[d], valid: cloneFornParams[d].value.trim(), errorMessage: data[d].errorMessage }
            }
        })
        setDataForm(cloneFornParams);
        let isError = 0
        Object.keys(cloneFornParams).forEach((k) => {
            if (!cloneFornParams[k]?.valid) {
                isError += 1
            }
        })
        return isError === 0
    }
    const resetData = () => {
        setDataForm(initData)
    }

    return {
        onFormValueChange,
        dataForm,
        handleVerfiy,
        setDataForm,
        resetData,
    }
}

// 自定义防抖Hook
export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const timeoutRef = useRef(null);

    useEffect(() => {
        // 清除之前的定时器
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // 设置新的定时器
        timeoutRef.current = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // 清除定时器
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [value, delay]);

    return debouncedValue;
}